
























import { Component } from 'vue-property-decorator';
import colors from 'vuetify/lib/util/colors';
import BtnSendThankMessage from '@/components/ViewComponent/Issue/IssueDetail/BtnResolveIssue/BtnSendThankMessage.vue';
import IssueItemFooterMixin from './issue-item-footer.mixin';

@Component<IssueItemFooterPc>({
  components: { BtnSendThankMessage },
})
export default class IssueItemFooterPc extends IssueItemFooterMixin {
  colors = colors;
}
